<template >
  <div id="collect_coupon">
    <div id="getcoupon">
      <div class="bck"></div>
      <div class="coupon_card">
        <img src="@/assets/img/coupon/collect_zx.png" alt v-if="logo===1&&isphone" />
        <img src="@/assets/img/coupon/collect_ldl.png" alt v-else-if="logo===2&&isphone" />
        <img src="@/assets/img/coupon/collect_zx2.png" alt v-if="logo===1&&!isphone" />
        <img src="@/assets/img/coupon/collect_ldl2.png" alt v-else-if="logo===2&&!isphone" />
        <div class="getcoupon_up">
          <Coupon :couponInfo="pickCoupon"></Coupon>
          <!-- <el-form ref="form" :model="form" label-width="80px">
          <div class="form_phone">
            <div class="phone_pre">+86</div>
            <div class="phone_input">
              <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
            </div>
            <div class="phone_clear" v-if="clearState" @click="clearPhone">
              <img src="@/assets/img/coupon/collect_clear.png" alt />
            </div>
          </div>
          <div class="form_phone">
            <div class="phone_codeinput">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            </div>
            <div class="phone_code" @click="getCode">
              <el-button
                type="primary"
                size="small"
                :style="show?'color:rgba(51, 51, 51, 0.4)':''"
                :disabled="show"
              >{{codeState}}</el-button>
            </div>
          </div>
          </el-form>-->
          <div :class="btnState?'btn_success':'btn_fail'" @click="onSubmit">{{btnText}}</div>
        </div>
        <div class="getcoupon_mid">
          <img :src="useinfo" alt />
        </div>
        <div class="getcoupon_down">
          <p v-for="(item,index) in tip" :key="index">{{item.content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>
// import api from '@/api/'
import Coupon from '@/components/Coupon'
import $ from 'jquery'
import moment from 'moment'
import api from '@/api'
import { mapActions, mapState } from 'vuex'
import { LOGIN_TYPE } from '@/utils/constants'
import utils from '@/utils/utils'
import wx from 'weixin-js-sdk'
export default {
  data () {
    return {
      logo: 1,
      useinfo: require('@/assets/img/coupon/useinfo.svg'),
      isphone: true,
      pickCoupon: {
        couponType: 'confirm',
        price: '',
        date: '',
        title: '',
        warnState: 0,
        pickType: 1,
        pickId: -1,
        warn: '',
        couponState: 0
      },
      btnState: true,
      btnText: '立即领取',
      codeState: '发送验证码',
      // form: {
      //   phone: '',
      //   code: ''
      // },
      couponGrantId: '',
      clearState: false,
      timer: null,
      count: '',
      show: false,
      tip: [
        {
          content:
            '1.礼券仅可以在购买质心官网 / 质心灵动量网站的课程时使用，不找零、无法兑现。'
        },
        {
          content:
            '2.不同礼券适用于不同的课程，且只支持用于购买整个课程（即购买部分小课时无法使用礼券）。'
        },
        { content: '3.礼券不可叠加使用，每个订单最多使用一张礼券。' },
        {
          content:
            '4.礼券有有效时间限制，以礼券上显示的结束日期为准，超过日期后则无法使用。'
        },
        {
          content:
            '5.生成订单后，所选的礼券会被锁定无法用于其它订单。若订单取消，则返还礼券。'
        },
        { content: '6.付款成功后，退款时不会返还礼券。' },
        { content: '7.礼券的最终解释权归质心教育所有。' }
      ]
    }
  },
  components: {
    Coupon
  },
  watch: {
    'form.phone': {
      handler: function () {
        if (this.form.phone) {
          this.clearState = true
        } else {
          this.clearState = false
        }
      }
    }
  },
  methods: {
    ...mapActions(['getUserInfo', 'logout']),
    clearPhone () {
      this.form.phone = ''
    },
    // 提交领取优惠券
    onSubmit () {
      if (!this.btnState) {
        return false
      } else if (!this.userInfo.mobile) {
        this.goLogin()
        return false
      } else {
        const data = {
          coupon_grant_id: this.couponGrantId,
          phone: this.userInfo.mobile
        }
        api
          .receiveCoupon(data)
          .then(r => {
            if (r.data.code === 1) {
              this.$message({
                message: '已领取礼券，可前往官网使用',
                type: 'success'
              })
              this.btnText = '已领取礼券'
              this.btnState = false
            } else {
              this.$message.error(r.data.message)
            }
          })
          .catch(e => {
            console.log('e: ', e)
          })
      }
    },
    goLogin () {
      this.zhuGeEventTrack(this.zhugeEvents.USER_ACTION.LOGIN_CLICK)
      this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
        this.getUserInfo().then(_ => {})
      })
    },
    getCode () {
      const phone = this.form.phone
      if (!phone) {
        this.$message.error('请输入手机号')
      } else if (
        phone.length !== 11 ||
        isNaN(phone) ||
        !/^1\d{10}$/.test(phone)
      ) {
        this.$message.error('请输入正确手机号')
      } else {
        const num = 60
        if (!this.timer) {
          this.count = num
          this.show = true
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= num) {
              this.count--
              this.codeState = this.count + 's重新发送'
            } else {
              this.show = false
              clearInterval(this.timer)
              this.timer = null
              this.codeState = '发送验证码'
            }
          }, 1000)
        }
      }
    },
    // 获取优惠券信息
    getCouponInfo () {
      const data = {
        uuid: this.$route.params.uuid
      }
      api
        .getCouponInfo(data)
        .then(r => {
          if (r.data.code === 1) {
            const item = r.data.data
            const nowTime = parseInt(new Date().getTime() / 1000)
            this.pickCoupon.date =
              moment.unix(item.start_time).format('YYYY.MM.DD') +
              '-' +
              moment.unix(item.end_time).format('YYYY.MM.DD')
            this.pickCoupon.title = item.title.slice(0, 12)
            this.pickCoupon.price = item.coupon_val / 100
            if (item.all_course) {
              if (item.goods_type === 5) {
                this.pickCoupon.warn = '适用范围：' + '面授课中，全部课程可用'
              } else if (item.goods_type === 2) {
                this.pickCoupon.warn = '适用范围：' + '直播课中，全部课程可用'
              }
            } else {
              if (item.goods_type === 5) {
                this.pickCoupon.warn =
                  '适用范围：面授课中，' + item.course_fullname + '可用'
              } else if (item.goods_type === 2) {
                this.pickCoupon.warn =
                  '适用范围：直播课中，' + item.course_fullname + '可用'
              }
            }
            this.couponGrantId = item.coupon_grant_id
            // '适用范围：'
            if (item.course_belong === '质心官网') {
              this.logo = 1
            } else if (item.course_belong === '质心灵动量') {
              this.logo = 2
            }
            if (item.exists) {
              this.btnText = '已领取礼券'
              this.btnState = false
            } else if (nowTime >= item.end_time) {
              this.btnText = '礼券已过期'
              this.btnState = false
            } else if (item.count - item.grant_count <= 0) {
              this.btnText = '礼券已领完'
              this.btnState = false
            }
            const title =
              '价值' +
              item.coupon_val / 100 +
              '元的学习礼券，点击领取，手慢无！'
            const desc =
              '价值' +
              item.coupon_val / 100 +
              '元的“' +
              item.course_fullname +
              '”，适用于' +
              this.pickCoupon.warn.slice(5) +
              '。'
            const link = process.env.VUE_APP_DOMIN + this.$route.path
            const $metaDesc = $('meta[name="description"]')
            document.title = title
            $metaDesc.attr('content', desc)
            utils.pageShare(wx, { title, desc, link })
          } else {
          }
        })
        .catch(e => {
          console.log('e: ', e)
        })
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin,
      userInfo: state => state.user.userInfo
    })
  },
  created () {
    if (document.body.clientWidth >= 768) {
      this.isphone = false
    }
    this.getCouponInfo()
  },
  mounted () {
    $('#footer').hide()
    $('.box-active1').hide()
    $('.banner').hide()
  }
}
</script>
<style lang="scss" >
#collect_coupon {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  z-index: 20;
  left: 0;
  top: 0;
  overflow-y: scroll;
  #getcoupon {
    max-width: 600px;
    margin: auto;
    background: linear-gradient(
      179deg,
      rgba(72, 210, 180, 1) 0%,
      rgba(0, 196, 188, 1) 100%
    );
    box-sizing: border-box;
    padding-bottom: 47px;
    //  height: 100%;
    // padding: 0px 16px;
    .bck {
      box-sizing: border-box;
      // padding: 48px 0px 22px 0px;
      background: url("~@/assets/img/coupon/collect_bg.png") no-repeat;
      background-size: 100% 100%;
      height: 185px;
    }
    .coupon_card {
      max-width: 520px;
      width: 91.7%;
      margin: auto;
      margin-top: -148px;
      img {
        margin-bottom: 22px;
      }
      .form_phone {
        height: 46px;
        border-radius: 4px;
        border: 1px solid rgba(51, 51, 51, 0.08);
        padding: 0px 8px 0px 12px;
        display: flex;
        align-items: center;
        margin: 24px 0px 16px 0px;
        .phone_input {
          width: 83%;
          .el-input__inner {
            border: none;
            padding: 0px 8px;
            font-size: 16px;
            color: rgba(51, 51, 51, 1);
            cursor: pointer;
          }
        }
        // .phone_codeinput {
        //   width: 70%;
        //   .el-input__inner {
        //     border: none;
        //     padding: 0px 8px;
        //     font-size: 16px;
        //     color: rgba(51, 51, 51, 1);
        //     cursor: pointer;
        //   }
        // }
        // .phone_code {
        //   font-size: 14px;
        //   color: rgba(0, 199, 191, 1);
        //   text-align: center;
        //   border-left: 1px solid rgba(51, 51, 51, 0.06);
        //   padding-left: 0.9rem;
        //   .el-button--primary {
        //     color: rgba(0, 199, 191, 1);
        //     background: white;
        //     border: none;
        //   }
        // }
        .phone_pre {
          font-size: 16px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .phone_clear {
          cursor: pointer;
          width: 24px;
          height: 24px;
        }
      }
    }
    .getcoupon_up {
      box-sizing: border-box;
      padding: 32px 16px 24px 16px;
      max-width: 520px;
      background: white;
      border-radius: 16px 16px 0px 0px;
      .btn_success {
        width: 81.3%;
        height: 42px;
        margin: auto;
        background: linear-gradient(
          131deg,
          rgba(255, 191, 84, 1) 0%,
          rgba(255, 160, 0, 1) 100%
        );
        box-shadow: 0px 3px 7px 0px rgba(197, 104, 5, 0.39);
        border-radius: 24px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 42px;
        margin-top: 36px;
        cursor: pointer;
      }
      .btn_fail {
        width: 81.3%;
        height: 42px;
        margin: auto;
        background: rgba(204, 204, 215, 1);
        box-shadow: none;
        border-radius: 24px;
        font-size: 16px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 42px;
        margin-top: 36px;
        cursor: not-allowed;
      }
      #coupon {
        width: auto !important;
        .coupon_content {
          .coupon_info {
            .coupon_infoup {
              margin-top: 0px !important;
            }
            .coupon_button {
              display: none;
            }
          }
        }
        .coupon_warn {
          margin-top: -8px;
          box-shadow: 0px 2px 12px 0px rgba(242, 212, 189, 0.5);
        }
        .coupon_narrowbck_success {
          background-size: cover;
        }
      }
    }
    .getcoupon_mid {
      // background: url("~@/assets/img/coupon/useinfo.svg") no-repeat;
      // background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
        margin-bottom: 0px;
      }
    }
    .getcoupon_down {
      background: white;
      box-sizing: border-box;
      padding: 8px 16px 24px 16px;
      border-radius: 0px 0px 16px 16px;
      p {
        font-size: 12px;
        color: rgba(51, 51, 51, 0.6);
        margin-bottom: 8px;
        line-height: 18px;
      }
    }
  }
  @media (min-width: 320px) {
    #getcoupon {
      .getcoupon_up {
        #coupon {
          .coupon_narrowbck_success {
            background-size: 100% 98%;
          }
        }
      }
      .getcoupon_mid {
        height: 45px;
      }
    }
  }
  @media (min-width: 375px) {
    #getcoupon {
      .getcoupon_up {
        #coupon {
          .coupon_content {
            height: 106px;
          }
        }
      }
      .getcoupon_mid {
        height: 47px;
      }
    }
  }
  @media (min-width: 414px) {
    #getcoupon {
      .getcoupon_up {
        #coupon {
          .coupon_content {
            height: 118px;
            .coupon_price {
              width: 120px;
            }
          }
        }
      }
      .getcoupon_mid {
        height: 51px;
      }
    }
  }
  @media (min-width: 768px) {
    #getcoupon {
      height: 100%;
      .getcoupon_up {
        #coupon {
          .coupon_content {
            .coupon_price {
              width: 168px;
            }
            .coupon_info {
              padding-left: 20px;
              flex: 1;
              .coupon_infoup {
                .coupon_info_content {
                  width: 100%;
                }
              }
            }
          }
        }
      }
      .getcoupon_mid {
        height: 70px;
      }
    }
  }
}
</style>
